
{
  "familyId": "GET-MACHT-GRONDTAL",
  "questions": [
    {
      "id": "GET-MACHT-GRONDTAL-001",
      "familyId": "GET-MACHT-GRONDTAL",
      "module": "Getalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_grondtal",
      "questionType": "multiple_choice",
      "question": "Wat is 2⁵?",
      "options": [
        "32",
        "10",
        "25",
        "64"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "macht_grondtal_2",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Strategie: vermenigvuldig het grondtal met zichzelf (exponent keer). Stap 1: 2⁵ = 2 × 2 × 2 × 2 × 2. Stap 2: 2 × 2 = 4, × 2 = 8, × 2 = 16, × 2 = 32.",
        "distractorExplanations": {
          "0": "Goed! 2⁵ = 2 × 2 × 2 × 2 × 2 = 32.",
          "1": "Veelgemaakte fout: vermenigvuldigen in plaats van machtsverheffen. 2 × 5 = 10, maar 2⁵ = 32.",
          "2": "Veelgemaakte fout: grondtal en exponent omdraaien. 5² = 25, maar 2⁵ = 32.",
          "3": "Veelgemaakte fout: 2⁶ berekenen. 2⁶ = 64, maar 2⁵ = 32 (één factor minder)."
        }
      }
    },
    {
      "id": "GET-MACHT-GRONDTAL-002",
      "familyId": "GET-MACHT-GRONDTAL",
      "module": "Getalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_grondtal",
      "questionType": "multiple_choice",
      "question": "Wat is 10³?",
      "options": [
        "1.000",
        "30",
        "100",
        "10.000"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "macht_grondtal_10",
      "variantIndex": 2,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.79,
      "feedback": {
        "explanationText": "Strategie: bij grondtal 10 is de exponent het aantal nullen. Stap 1: 10³ = 10 × 10 × 10 = 1.000. Stap 2: Exponent 3 → 3 nullen → 1.000.",
        "distractorExplanations": {
          "0": "Goed! 10³ = 1.000. Bij grondtal 10: exponent = aantal nullen.",
          "1": "Veelgemaakte fout: vermenigvuldigen. 10 × 3 = 30, maar 10³ = 1.000.",
          "2": "Veelgemaakte fout: 10² berekenen. 10² = 100, maar 10³ = 1.000.",
          "3": "Veelgemaakte fout: 10⁴ berekenen. 10⁴ = 10.000, maar 10³ = 1.000."
        }
      }
    },
    {
      "id": "GET-MACHT-GRONDTAL-003",
      "familyId": "GET-MACHT-GRONDTAL",
      "module": "Getalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_grondtal",
      "questionType": "multiple_choice",
      "question": "Wat is (−3)²?",
      "options": [
        "9",
        "−9",
        "−6",
        "6"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "macht_negatief_grondtal_even",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Strategie: een negatief getal tot een even macht is positief. Stap 1: (−3)² = (−3) × (−3). Stap 2: Min × min = plus. Stap 3: 3 × 3 = 9. Antwoord: +9.",
        "distractorExplanations": {
          "0": "Goed! (−3)² = (−3) × (−3) = +9. Even exponent → positief resultaat.",
          "1": "Veelgemaakte fout: het minteken behouden. (−3)² = +9, niet −9. Min × min = plus.",
          "2": "Veelgemaakte fout: vermenigvuldigen. −3 × 2 = −6, maar (−3)² = (−3) × (−3) = 9.",
          "3": "Veelgemaakte fout: 3 × 2 = 6. Machtsverheffen ≠ vermenigvuldigen."
        }
      }
    },
    {
      "id": "GET-MACHT-GRONDTAL-004",
      "familyId": "GET-MACHT-GRONDTAL",
      "module": "Getalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_grondtal",
      "questionType": "multiple_choice",
      "question": "Wat is (−2)³?",
      "options": [
        "−8",
        "8",
        "−6",
        "6"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "macht_negatief_grondtal_oneven",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Strategie: een negatief getal tot een oneven macht is negatief. Stap 1: (−2)³ = (−2) × (−2) × (−2). Stap 2: (−2) × (−2) = +4. Stap 3: +4 × (−2) = −8.",
        "distractorExplanations": {
          "0": "Goed! (−2)³ = −8. Oneven exponent → negatief resultaat.",
          "1": "Veelgemaakte fout: het minteken weglaten. (−2)³ = −8, niet +8. Oneven exponent → negatief.",
          "2": "Veelgemaakte fout: vermenigvuldigen. −2 × 3 = −6, maar (−2)³ = (−2) × (−2) × (−2) = −8.",
          "3": "Veelgemaakte fout: 2 × 3 = 6. Machtsverheffen ≠ vermenigvuldigen."
        }
      }
    }
  ]
}
